<template>
  <div>
    <div class="mt-4">
      <div class="mb-3">
        <p class="text-primary-yellow font-semibold"></p>
      </div>
      <div class="text-base text-secondary-yellow pb-3">Routes Details</div>
      <div class="container-fluid mb-4">
        <div class="row justify-content-between">
          <div class="col-md-6 col-lg-6 col-12">
            <div style="width: 500px">
              <label class="label">Originating Terminal</label>

              <el-select @change="startName()" filterable v-model="routeStart.id" placeholder="Select">
                <el-option label="--Select--" value="null">
                </el-option>
                <el-option v-for="location in locations" :key="location.id" :label="location.locationName"
                  :value="location.id">
                </el-option>
              </el-select>

              <div class="flex flex-row justify-end gap-4 lg:justify-between flex-wrap">
                <label class="hidden text-sm lg:block">
                  Do you offer last mile services from this terminal
                </label>

                <label class="lg:hidden flex gap-2">
                  <el-tooltip content="Do you offer last mile services from this terminal" class="mt-1" placement="top">
                    <span>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
                          fill="#383F51" />
                      </svg>
                    </span>
                  </el-tooltip>
                  Last Mile?
                </label>

                <div class="flex gap-4 text-sm">
                  <b-form-radio v-model="routeStart.lastMile" name="lastMileOrigin" value="No">No</b-form-radio>
                  <b-form-radio class="inline-block" v-model="routeStart.lastMile" name="lastMileorigin"
                    value="Yes">Yes</b-form-radio>
                </div>
              </div>
            </div>
            <div class="" style="width: 500px">
              <label class="label">Route Name</label>
              <input disabled type="text" class="input bg-white w-96" v-model="routeName" />
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-12 pt-1">
            <label class="label">Destination Terminal</label>
            <el-select filterable @change="terminateName()" v-model="routeEnd.id" placeholder="Select">
              <el-option label="--Select--" value="null">
              </el-option>
              <el-option v-for="location in locations" :key="location.id" :label="location.locationName"
                :value="location.id">
              </el-option>
            </el-select>
            <div class="flex flex-row justify-end gap-4 text-sm lg:justify-between flex-wrap">
              <div class="flex flex-row justify-end gap-4 lg:justify-between flex-wrap">
                <label class="hidden text-sm lg:block">
                  Do you offer last mile services from this terminal
                </label>

                <label class="lg:hidden flex gap-2">
                  <el-tooltip content="Do you offer last mile services from this terminal" class="mt-1" placement="top">
                    <span>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
                          fill="#383F51" />
                      </svg>
                    </span>
                  </el-tooltip>
                  Last Mile?
                </label>

                <div class="flex gap-4">
                  <b-form-radio v-model="routeEnd.lastMile" name="lastMile" value="No">No</b-form-radio>
                  <b-form-radio class="inline-block" v-model="routeEnd.lastMile" name="lastMile"
                    value="Yes">Yes</b-form-radio>
                </div>
              </div>
            </div>

            <div class="">
              <label class="label">Medium</label>
              <el-select filterable v-model="routeMedium" placeholder="Select">
                <el-option label="--Select--" value="null">
                </el-option>
                <el-option label="Land" value="Land"> </el-option>
                <el-option label="Sea" value="Sea"> </el-option>
                <el-option label="Air" value="Air"> </el-option>
                <el-option label="Rail" value="Rail"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mb-4">
        <div class="row"></div>
      </div>
    </div>

    <div class="mt-4 flex items-center gap-5" v-if="routeTripBreaks.length == 0 && !showAddTripBreak">
      <!-- for mobile screens only -->
      <div @click="tripOperations()" :style="{ color: '#FCC210' }" class="lg:hidden w-full flex justify-between">
        Add trip break
        <ArrowDownIcon v-if="showAddTripBreak" class="mt-2" />
        <ArrowUpIcon v-if="!showAddTripBreak" class="mt-2" />
      </div>
      <!---->

      <!-- for large screen -->
      <div class="hidden lg:flex gap-12">
        <p class="flex gap-4 items-center">
          Do you want to add a trip break?
          <el-tooltip content="Trip Break" placement="top">
            <span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
                  fill="#383F51" />
              </svg>
            </span>
          </el-tooltip>
        </p>
        <base-button text="Add a trip break" @click="tripOperations" />
      </div>
      <!---->
    </div>

    <!-- for mobile screen -->
    <div v-if="routeTripBreaks.length > 0 || showAddTripBreak" @click="tripOperations2()" :style="{ color: '#FCC210' }"
      class="lg:hidden w-full flex justify-between">
      Add trip break
      <ArrowDownIcon v-if="showAddTripBreak" class="mt-2" />
      <ArrowUpIcon v-if="!showAddTripBreak" class="mt-2" />
    </div>
    <!--- -->
    <div v-if="routeTripBreaks.length > 0 && showAddTripBreak" class="mt-4">
      <div class="mb-3 sm:hidden md:block">
        <p class="text-primary-yellow font-semibold">Trip Breaks</p>
      </div>

      <div class="container-fluid mb-4">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-12" v-for="(tripBreak, index) in routeTripBreaks" :key="index">
            <div class="flex justify-between">
              <label class="font-semibold">Trip Break {{ index + 1 }}</label>
              <span @click="removeTripBreak(index)" class="p-2 cursor-pointer text-red-500">Remove this trip
                Break</span>
            </div>

            <el-select filterable v-model="routeTripBreaks[index].name" placeholder="Select">
              <el-option value="--Select--">-- Select --
              </el-option>
              <el-option v-for="city in allCities" :key="city" :label="city" :value="city">
              </el-option>
            </el-select>
            <div class="">
              <span>Do you offer last mile services from this terminal</span>
              <div class="flex mt-1 gap-4">
                <div class="single-option">
                  <label for="noEnd" class="radio-label">
                    <input class="bg-primary-yellow text-secondary-yellow" name="routeEnd" type="radio" id="noEnd"
                      value="No" v-model="routeEnd.lastMile" />
                    No
                    <span></span>
                  </label>
                </div>

                <div class="single-option">
                  <label for="yesEnd" class="radio-label">
                    <input type="radio" v-model="routeEnd.lastMile" value="Yes" id="yesEnd" name="routeEnd" />
                    Yes
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <base-button class="-ml-4" text="Add another trip break" @click="addTripBreak" />
      </div>
    </div>
    <route-schedule-form @update-route-schedule="updateRouteSchedule" :routeSchedules="preSchedules" ref="routeSchedule"
      :forward="forward" :backward="backward" />

    <div class="button-wrapper">
      <p class="cursor-pointer" @click="$router.push({ name: 'Routes' })">
        Cancel
      </p>
      <base-button text="Create Route" :loading="apiCalling" v-if="!edit" @click="createRoute" />

      <base-button text="Update Route" :loading="apiCalling" v-else @click="updateRoute" />
    </div>
  </div>
</template>

<script>
import RouteScheduleForm from "./RouteScheduleForm";
import ArrowDownIcon from "@/components/UI/svgs/ArrowDownIcon.vue";
import ArrowUpIcon from "@/components/UI/svgs/ArrowUpIcon.vue";

export default {
  components: {
    RouteScheduleForm,
    ArrowDownIcon,
    ArrowUpIcon,
  },
  props: {
    states: {
      type: Array,
      default: () => [],
    },
    setTripBreak: {
      type: Function,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    route: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      routeName: "",
      routeMedium: "",
      allCities: null,
      forward: "",
      backward: "",
      routeStart: {
        id: "",
        name: "",
        start: "",
        lastMile: "No",
        cities: [],
      },
      routeEnd: {
        id: "",
        name: "",
        terminal: "",
        lastMile: "No",
        cities: [],
      },
      routeTripBreaks: [],
      routeSchedule: null,
      apiCalling: false,
      locations: [],
      showAddTripBreak: false,
    };
  },
  mounted() {
    if (this.edit) {
      this.routeStart.name = this.route.takeOffLocation;
      this.routeEnd.name = this.route.arrivalLocation;
      this.routeMedium = this.route.shippingMethod;
    }
    this.getAllCities();

    this.getAllLocations();
  },
  methods: {
    getCitiesByState(name, type) {
      try {
        if (type === "start") {
          this.routeStart.cities = this.states.find(
            (state) => state.name == name
          ).cities;
        } else if (type === "end") {
          this.routeEnd.cities = this.states.find(
            (state) => state.name == name
          ).cities;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    tripOperations() {
      this.addTripBreak();
      this.showAddTripBreak = !this.showAddTripBreak;
    },
    tripOperations2() {
      this.showAddTripBreak = !this.showAddTripBreak;
    },
    async getAllLocations() {
      try {
        const response = await this.$_getAllLocations();

        this.log(response);
        this.locations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    terminateName() {
      this.routeEnd.name =
        this.locations.length > 0
          ? this.locations.find((x) => x.id == this.routeEnd.id)?.state
          : "";
      this.routeEnd.terminal =
        this.locations.length > 0
          ? this.locations.find((x) => x.id == this.routeEnd.id)?.locationName
          : "";
    },
    startName() {
      this.routeStart.name =
        this.locations.length > 0
          ? this.locations.find((x) => x.id == this.routeStart.id)?.state
          : "";
      this.routeStart.start =
        this.locations.length > 0
          ? this.locations.find((x) => x.id == this.routeStart.id)?.locationName
          : "";
    },
    async getAllCities() {
      try {
        const response = await this.$_getAllCities();
        this.allCities = response.data.allCity;
        console.log(JSON.stringify(response.data, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },
    addTripBreak() {
      this.routeTripBreaks.push({
        name: "",
      });
    },

    updateRouteSchedule(schedules) {
      this.routeSchedule = schedules;
    },

    removeTripBreak(index) {

      this.routeTripBreaks.splice(index, 1);

      if (index == 0 && this.routeTripBreaks.length == 0) {
        this.showAddTripBreak = false
      }

    },

    async createRoute() {
      this.apiCalling = true;
      try {
        await this.$_createRoute(this.payload);
        this.apiCalling = false;
        this.$router.push({ name: "Routes" });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.apiCalling = false;

      }
    },

    async updateRoute() {
      this.apiCalling = true;
      try {
        await this.$_updateRoute(this.payload, this.route.id);
        this.apiCalling = false;
        this.generateToast("Route has been updated successfully", "success");
        this.$router.push({ name: "Routes" });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.apiCalling = false;

      }
    },
  },
  computed: {
    preSchedules() {
      return this.edit ? this.route.schedule : [];
    },
    commonCities() {
      return [...this.routeStart.cities, ...this.routeEnd.cities];
    },

    payload() {
      return {
        payload: {
          orgName:
            this.$store.state.authentication.organizationDetails.companyname,
          orgId: localStorage.getItem("organizationId"),
          isPrimary: true,
          isInterstate: true,
          isIntrastate: false,
          routeName: this.routeName,
          shippingMethod: this.routeMedium,
          takeOffId: this.routeStart.id,
          arrivalId: this.routeEnd.id,
          takeOffLocation: this.routeStart.name,
          arrivalLocation: this.routeEnd.name,
          trip: this.routeTripBreaks,
          terminalType: "terminal-to-terminal",
          cities: [
            { start: this.routeStart.start, terminal: this.routeEnd.terminal },
          ],
          schedule: this.routeSchedule,
        },
      };
    },
  },

  watch: {
    routeTripBreaks: {
      deep: true,
      immediate: true,
      handler(val) {
        let hasLength = val.length > 0
        this.setTripBreak(hasLength)
      }
    },
    "routeStart.name": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCitiesByState(val, "start");
          this.routeName = val + "-" + this.routeEnd.name;
          this.forward = val;
        }
      },
    },

    "routeEnd.name": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCitiesByState(val, "end");
          this.routeName = this.routeStart.name + "-" + val;
          this.backward = val;
        }
      },
    },
    payload: {
      deep: true,
      immediate: true,
      handler(val) {
        val;
      },
    },

    route: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(JSON.stringify(val, null, 2));
        if (val) {
          this.routeName = val.routeName;
          this.routeMedium = val.shippingMethod;
          this.routeSchedule = val.schedule;
        }
      },
    },
  },
};
</script>

<style></style>
